export enum NotificationStatus {
  NEW = 0,
  SEEN = 1,
}
